/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Section_EmptyInputs */



/**
* | output |
* | --- |
* | "Write what you want to raise here." |
*
* @param {Meeting_Prep_Section_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_section_empty = /** @type {((inputs?: Meeting_Prep_Section_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Section_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Schrijf hier wat je wil aankaarten.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Écrivez ici ce que vous voulez aborder.")
	return /** @type {LocalizedString} */ ("Write what you want to raise here.")
});